import { MainNavScreens } from "breadcommon";

type MainNavDefinition = {
  label: string;
  /**
   * The tab's first URL segment. Tabs share the root URL namespace with the
   * marketing pages routed in Router.tsx, so check those before adding one.
   */
  slug: string;
  icon: string;
  /** Old slugs that still open this tab, so existing links keep working. */
  legacySlugs?: string[];
};

export const MAIN_NAV_DEFINITIONS: Record<MainNavScreens, MainNavDefinition> = {
  HOME: { label: "Home", slug: "home", icon: "home" },
  BUDGETS: { label: "Budgets", slug: "budgets", icon: "map" },
  TRANSACTIONS: {
    label: "Transactions",
    slug: "transactions",
    icon: "checklist_rtl",
  },
  BALANCES: {
    label: "Balances",
    slug: "balances",
    icon: "savings",
  },
  CASH_FLOW: {
    label: "Cash Flow",
    slug: "cash-flow",
    icon: "bar_chart",
    legacySlugs: ["reports"],
  },
};

/** The order tabs appear in, in the nav and wherever they're listed. */
export const MAIN_NAV_ORDER: MainNavScreens[] = [
  "HOME",
  "TRANSACTIONS",
  "BALANCES",
  "CASH_FLOW",
  "BUDGETS",
];

export function mainNavPath(screen: MainNavScreens): string {
  return `/${MAIN_NAV_DEFINITIONS[screen].slug}`;
}

/** The tab a URL's first segment opens, or null if it isn't a tab. */
export function mainNavScreenForSlug(slug: string): MainNavScreens | null {
  const match = Object.entries(MAIN_NAV_DEFINITIONS).find(
    ([, definition]) =>
      definition.slug === slug || definition.legacySlugs?.includes(slug),
  );
  return match ? (match[0] as MainNavScreens) : null;
}
